import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { THEME_SETTINGS } from "@theme-settings";
import { ISOToDisplayCode, getCurrentCulture } from "@utils";

import { ReactLazyImportWithGuard as lazy } from "@lib/lazy-import-with-guard";
import { getLoginReturnUrl } from "@utils/auth";

const loadFailPath = `/${getCurrentCulture()}/app-update`;

// prettier-ignore
const ReactMarkdown = lazy(loadFailPath, () => import("react-markdown"));

export default function HeaderBonusAnnouncement() {
	const { t } = useTranslation();

	return (
		<Link className="header__top__link" to={getLoginReturnUrl()}>
			<i className="header__top__icon u-icon u-icon--base u-icon--bonus--str u-color--core--snow" />
			<ReactMarkdown className="header__top__caption header__top__markdown">
				{t("WELCOME_BONUS.ANNOUNCEMENT", {
					amount: THEME_SETTINGS.welcomeBonusAmount,
					currency: ISOToDisplayCode(THEME_SETTINGS.defaultCurrency),
				})}
			</ReactMarkdown>
		</Link>
	);
}
